import { render, staticRenderFns } from "./TopTabs.vue?vue&type=template&id=27dd467c"
import script from "./TopTabs.vue?vue&type=script&lang=js"
export * from "./TopTabs.vue?vue&type=script&lang=js"
import style0 from "./TopTabs.vue?vue&type=style&index=0&id=27dd467c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports